import React from "react";
import ReadingsContent from "../../features/readings/components/ReadingsContent";

export default function Readings() {
  /**
   * Readings (v4)
   *
   * Página oficial do domínio Readings.
   * Nesta etapa, ela apenas orquestra a feature.
   */
  return <ReadingsContent />;
}